import { createAction, props } from '@ngrx/store';
import { UserProp } from './user.prop';

export const setLogin = createAction('[User Auth] Login', props<UserProp>());
